import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { getLanguage, useTranslation } from 'react-multi-lang';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import {  billsSlice, billsState } from './BillsSlice';


// API
import API , {bill, sortDirectionType}from '../../services/api/api';

// Components
import TableActionBar from '../../components/TableActionBar/TableActionBar';

import { EllipsisLoader, WhiteboxLoader } from '../../components/Loader/Loader';
import { Confirm } from '../../components/Alerts/Alerts';

import { havePermission } from '../../services/hoc/permissions';

import { useLocation, useNavigate } from 'react-router-dom';
import SettingContext from '../../services/context/setting-contentxt/setting-context';

import { Print, Launch } from '@mui/icons-material';
import { PrintBill } from '../../components/print/print_bill';
import { Wait } from '../../components/wait';
import { IconButton } from '../../components/icon-button';
import { Tooltip } from '@mui/material';
import { getListSort } from '../../services/hoc/sort';
import { SortTable } from '../../components/Table/SortTable';
import { RowContainer } from '../../components/Table/row_container';

import { useAPI } from '../../services/hoc/useAPI';
import { AxiosError } from 'axios';
import { useNotification } from '../../services/usenotification';
export default () => {
  // Translation
  const t = useTranslation();
  const [pagesInfo, setPagesInfo] = useState({ page: 1, lastPage: 1 });
  const [printBill, setPrintBill] = useState<{open:boolean,data:any}>({ open: false, data: {} });
  const [wait, setWait] = useState(false);
  const location = useLocation();
  const keyword_ref = useRef<string|null>(null)
  const {alertError500} = useNotification()

  const navigate = useNavigate();
  const { setAlert } = useContext(SettingContext);
  const sort_fields = useRef<{sort_field?:number,sort_direction?:sortDirectionType}>({})
  // Redux
  const dispatch = useDispatch();
  const state = useSelector((state: { bills: billsState }) => state.bills);



const ENDPOINTS = useAPI()
  // Table ref

  // Search
  // const search = (value: string) => {
  //     tableRef.current?.reset()
  //     dispatch( billsSlice.actions.reset() )
  //     setKeyword(value)
  // }
  const search = (value: string) => {
   
    dispatch(billsSlice.actions.reset());
    keyword_ref.current=Boolean(value)?value:null
   
    fetchData(1,Boolean(value)? 20:8, value);
  };

  // Fetch Data
  const fetchData =useCallback( (
    page: number,
    page_size: number = 10,
    keyword: string = '',
    sort_direction?:sortDirectionType,
    sort_field?:number
  
  ) => {
 
    dispatch(billsSlice.actions.setIsFetching(true));
   keyword=Boolean(keyword)?keyword:keyword_ref.current?keyword_ref.current:''
    ENDPOINTS.bills()
      .index({ page, page_size, keyword ,sort_direction,sort_field })
      .then((response: any) => {
        dispatch(billsSlice.actions.setIsFetching(false));
        dispatch(billsSlice.actions.setPage(pagesInfo.page));
        if (response.data.data.last_page)
          setPagesInfo((pre) => ({
            ...pre,
            lastPage: response.data.data.last_page,
          }));
        let bills: bill[] = response.data.data.bills.map(
          (bill: any): bill => bill,
        );

        dispatch(billsSlice.actions.initializeBills(bills));
        dispatch(
          billsSlice.actions.setHasMore(
            page < Number(response.data.data.last_page),
          ),
        );
        if (!state.isLoaded) dispatch(billsSlice.actions.setIsLoaded(true));
      })
      .catch((err:AxiosError)=>{
                   dispatch(billsSlice.actions.setIsFetching(false));
                   alertError500(err)
 
      })
  },[ENDPOINTS,dispatch,pagesInfo.page,state.isLoaded])

  const fetchSortedData =useCallback ((sort_field:number,sort_direction:sortDirectionType)=>{
    if (sort_direction && sort_field){
               sort_fields.current.sort_direction=sort_direction 
      sort_fields.current.sort_field=sort_field

     
       fetchData(state.page,8,'',sort_direction,sort_field)
    }
  }
  ,[state.page])



  const invoiceIssued=(bill:bill)=>(
    <div
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
      style={{
        display: 'flex',
        alignItems: 'center',
        paddingInline:'10px'
      }}>
      <IconButton
        doTitle={t('print_bill')}
        disabled={!havePermission("Print Bill")}
        doFunction={() => {
          setWait(true);
          setPrintBill((pre) => ({
            ...pre,
            open: true,
            data: bill.id,
          }));
          return true;
        }}
        DoIcon={<Print sx={{ color: 'var(--primary-color)' }} />}
        value={false}
        cancelTitle={t('print_bill')}
      />
    </div>
  )
  const gotToORder=(bill:bill)=>(
    <IconButton
    DoIcon={<Launch sx={{color:'var(--primary-color)'}}/>}
    cancelTitle=''
    doTitle={t("show_order")}
    value={false}

   style={{margin:'0 5px'}}
    doFunction={()=>{
     {
      navigate(`/orders/${bill.order_id}`);
      return true
     }
    }}
     />
  )
  const actions =(bill:bill)=> (
    <div className="show-on-hover">
      {havePermission('Show Bill') ? (
        <Tooltip title={t('info')}>
          <i
            className="icon-info"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              navigate(`/bills/${bill.id}`);
            }}
          />
        </Tooltip>
      ) : (
        ''
      )}

      
    </div>
  )
  const rows =()=>{
    
    return (
      state.bills[state.page]
      ? state.bills[state.page]!.map((bill, index) => {
        return (
          <RowContainer 
           item_id={bill.id?.toString() as string}
           onSelect={toggleSelectedId}
           state_length={state.bills[state.page]?.length as number}
           tr_index={index}
           columns={[
            bill.bill_no,
            bill.date?.replaceAll('-','/'),
            bill.client?.name,
            bill.order_no,
            bill.date?.replaceAll('-','/'),
            invoiceIssued(bill),
            gotToORder(bill),
            actions(bill)
           ]}
          />
        )
      }):null
    )
  }

  // Toggle Selected id
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const toggleSelectedId = (id: number) => {
    if (!havePermission('Delete Bill')) return;
    let index = selectedIds.findIndex((selectedId) => selectedId === id);
    if (index !== -1) {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else setSelectedIds([...selectedIds, id]);
  };

  // Delete
  const remove = (id?: number) => {
    let ids = id ? [id] : selectedIds.map((x) => +x);
    dispatch(billsSlice.actions.setIsLoading(true));
    ENDPOINTS.bills()
      .delete({ ids })
      .then((res: any) => {
        setSelectedIds([]);
        dispatch(billsSlice.actions.setIsLoading(false));
        dispatch(billsSlice.actions.deleteBills(ids));
      })
      .catch((err: any) => {
        dispatch(billsSlice.actions.setIsLoading(false));
        setAlert((pre: any) => ({
          ...pre,
          alertMessage:
            getLanguage() === 'en'
              ? 'Can not delete this item '
              : 'لا يمكن حذف هذا العنصر',
          alertType: 'error',
          openAlert: true,
        }));
        if (err.errors && typeof err.errors === 'object') {
          let messages: string[] = [];
          Object.keys(err.errors).map((ele) => {
            if (err.errors[ele] && typeof err.errors[err] === 'object') {
              messages.push(err.errors[ele][0]);
            }
          });
          if (messages.length > 0) {
            messages.map((ele: string) => {
              setAlert((pre: any) => ({
                ...pre,
                alertMessage: ele,
                alertType: 'error',
                alertOpen: true,
              }));
            });
          }
        }
      });
  };

  // First fetch

  useEffect(() => {
    if (pagesInfo && pagesInfo.page !== state.page) {
      if (!state.isFetching) {
        billsSlice.actions.setPage(pagesInfo.page);
       
        fetchData(pagesInfo.page,8,'',sort_fields.current.sort_direction,sort_fields.current.sort_field);
      }
    }
  }, [pagesInfo]);
  
  useEffect(() => {
 if (!state.isFetching) {
    if (location.state) {
      
       
        search(location.state.key);
      
    } else {
      
       
        fetchData(1,8,'','DESC',23);
      }
    }
  }, [location.state]);

  return (
    <>
      {state.isLoaded ? (
        <>
          {state.isLoading ? <WhiteboxLoader /> : ''}

          <TableActionBar
            title={t('bills')}
            keyword={location.state ? location.state.key : ''}
            search={search}
            showFilter={false}
            showDelete={selectedIds.length > 0}
            delete={() => {
              Confirm({
                message: t('delete_confirmation'),
                onConfirm: () => remove(),
              });
            }}
            addText={t('add_to_bills')}
            add={
              havePermission('Add Bill')
                ? () => {}
                : undefined
            }
          />

          {/* <DashboardTable
            
            header={[
              t('bill_no'),
              t('date'),
              t('client'),
              t('order_no'),
              t("order_date"),
              t('print_bill'),
              t('go_to_order'),
              '',
            ]}
            body={generateData()}
            onSelect={toggleSelectedId}
            hasMore={state.hasMore}
            loadMore={fetchData}
            pagesInfo={pagesInfo}
            setPagesInfo={setPagesInfo}
            sort_fields={getListSort(['bill_no'
            ,'bill_date','client_name','order_no','order_date','print_bill','goto',''],'Bills')}
            fetchSortedData={fetchSortedData}
          /> */}
          <SortTable 
            header={[
              t('bill_no'),
              t('date'),
              t('client'),
              t('order_no'),
              t("order_date"),
              t('print_bill'),
              t('go_to_order'),
              '',
            ]}
            state={state.bills[state.page]??[]}
            onSelect={toggleSelectedId}
            hasMore={state.hasMore}
            loadMore={fetchData}
            pagesInfo={pagesInfo}
            setPagesInfo={setPagesInfo}
            sort_fields={getListSort(['bill_no'
            ,'bill_date','client_name','order_no','order_date','print_bill','goto',''],'Bills')}
            fetchSortedData={fetchSortedData}
          >
            <>
            {
              rows()
            }
            </>

          </SortTable>

          {/* <AddModal /> */}
{/* 
          <ShowClient /> */}
          <div
            id="includeMe"
            style={{ position: 'absolute', visibility: 'hidden', zIndex: -1 }}>
            {printBill.open && (
              <PrintBill
                close={() => setPrintBill((pre) => ({ ...pre, open: false }))}
                data={printBill.data}
                setWait={setWait}
              />
            )}
          </div>
          {wait && <Wait />}
        </>
      ) : (
        <div className="center">
          <EllipsisLoader />
        </div>
      )}
    </>
  );
};
